//  Name: course-card
import { slugify } from '@/helpers/utils'
import '@/components/price'

export default {
  props: {
    course: {
      required: true
    },
    price: {
      type: Boolean,
      required: false,
      default: false
    },
    teachers: {
      type: Boolean,
      required: false,
      default: false
    },
    go: {
      type: Boolean,
      required: false,
      default: false
    },
    external: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    place () {
      let route = {
        name: 'Curso',
        params: {
          slug: slugify(this.course.name) + '-' + this.course.id
        }
      }
      return (this.external) ? this.course.external: this.course.short_description
    },
    text () {
      return (this.go) ? 'Ir al curso' : 'Ver curso'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/course-card/script.js